import { LoanOfferGenService } from './../services/loan-offer-gen.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-personal-loan-main',
  templateUrl: './personal-loan-main.component.html',
  styleUrls: ['./personal-loan-main.component.css']
})
export class PersonalLoanMainComponent implements OnInit {
  currentUrl: string;
  
    personalcat:boolean=true;
    reducepersonalcat:boolean=false;
  
    personaLoan:boolean=false;
    personalblt:boolean=false
  
    personal_loan_mob:boolean=false;
    personal_loan_mob_balance:boolean=false;
  
    
    constructor(
      private route: Router,
      private router:ActivatedRoute,
      private LoanOfferService:LoanOfferGenService
   
    ) {
      this.currentUrl=this.route.url;
      let n=this.currentUrl.lastIndexOf('/');
      let url= this.currentUrl.substring(n + 1);
      this.navigateBetweenOffers(url);
     }
     banner_data=[
      {
      title:'Best Personal loan offers in 2 steps',
      banner_text:"Loan offers from 10+ Banks,Maximum Loan eligibility upto 28 times of monthly net salary,Part Payment facility from 4 Banks"
      }
  ]
  
    ngOnInit() {
    }
    showPLForm(value,link){
      this.LoanOfferService.ShowPl(value);
      this.navigateBetweenOffers(link); 
    }
    navigateBetweenOffers(link){
      if(link=='new'){
       this.personaLoan=true;
       this.personalblt=false; 
      }
      if(link=='transfer'){
        this.personaLoan=false;
        this.personalblt=true; 
      }
  
      this.route.navigate([link]
        ,{ relativeTo: this.router});
    }
    mobilePlForm( value,link){
      this.LoanOfferService.ShowPl(value);
      this.navigateBetweenOffersMobile(link);
    }
  
    navigateBetweenOffersMobile(link){
      if(link=='new'){
        this.personalcat=true;
        this.reducepersonalcat=false;
        
        this.personal_loan_mob=true;
        this.personal_loan_mob_balance=false;
      }
      if(link=='transfer'){
        this.personalcat=false;
        this.reducepersonalcat=true;
  
        this.personal_loan_mob=false;
        this.personal_loan_mob_balance=true;
       
      }
      this.route.navigate([link]
       ,{ relativeTo: this.router});
    }
  

}



// WEBPACK FOOTER //
// ./src/app/loan/personal-loan-main/personal-loan-main.component.ts